export const disclaimerModalType = "disclaimer";
